
import React, { useState } from 'react';
import { Button } from '@/components/ui/button';
import { CreditCard } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { Client } from '@/models/Client';
import PaymentDialog from './PaymentDialog';

interface PaymentStatusButtonProps {
  client: Client;
  size?: 'default' | 'sm' | 'lg' | 'icon';
  variant?: 'default' | 'destructive' | 'outline' | 'secondary' | 'ghost' | 'link';
}

const PaymentStatusButton: React.FC<PaymentStatusButtonProps> = ({ 
  client, 
  size = 'sm',
  variant = 'outline'
}) => {
  const { t } = useTranslation();
  const [showPaymentDialog, setShowPaymentDialog] = useState(false);

  return (
    <>
      <Button
        onClick={() => setShowPaymentDialog(true)}
        size={size}
        variant={variant}
        className={size === 'icon' ? '' : 'flex items-center gap-2'}
        title={size === 'icon' ? t('clients.paymentStatus') : undefined}
      >
        <CreditCard className="h-4 w-4" />
        {size !== 'icon' && t('clients.paymentStatus')}
      </Button>

      <PaymentDialog
        open={showPaymentDialog}
        onOpenChange={setShowPaymentDialog}
        clientId={client.id}
        clientName={`${client.firstName} ${client.lastName}`}
        client={client}
      />
    </>
  );
};

export default PaymentStatusButton;
